import { AxiosError } from 'axios';
import useSalesPortalConfiguration from 'hooks/salesPortal/useSalesPortalConfiguration';
import useSalesPortalKiloClass from 'hooks/salesPortal/useSalesPortalKiloClass';
import { useParams, useSearchParams } from 'react-router-dom';
import { ErrorMessage, SalesPortalKiloClassRetrieve } from 'types';

type UseSalesPortalKiloClassResult = {
  data: { data: SalesPortalKiloClassRetrieve } | undefined;
  kiloClassId?: string;
  isError: boolean;
  isLoading: boolean;
  error: AxiosError<ErrorMessage> | undefined;
  errorStatus: number | undefined;
};

export default function useSalesPortalKiloClassFromUrlParam(): UseSalesPortalKiloClassResult {
  const { salesPortalSlug } = useParams<{ salesPortalSlug: string }>();
  const { data: salesPortalConfig } = useSalesPortalConfiguration(salesPortalSlug);
  const [searchParams] = useSearchParams();
  const kiloClassId = searchParams.get('kc') ?? undefined;

  const { data, isError, isLoading, error } = useSalesPortalKiloClass({
    gymId: salesPortalConfig?.data.gym.gymId ?? undefined,
    kiloClassId,
  });

  return {
    data,
    isError,
    isLoading,
    kiloClassId,
    error: error as AxiosError<ErrorMessage> | undefined,
    errorStatus: (error as AxiosError<ErrorMessage>)?.response?.status,
  };
}
